import { gql } from "@apollo/client";
import {
  CuratedSearchDesignInternalFiltersStep_AutopilotSearchDesignInternalFiltersStepFragment,
  InternalCuratedSearchFilters,
} from "../../../../__generated__/graphql";
import { useContext, useState } from "react";
import AutopilotCuratedInternalSearchContext, {
  AutopilotCuratedInternalSearchContext_InternalSearchFilters,
} from "../../../../contexts/AutopilotCuratedInternalSearchContext";
import CuratedInternalSearchFilterCard from "../../CuratedSearchFilters/CuratedInternalSearchFilterCard";

export const CuratedSearchDesignInternalFiltersStep_AutopilotSearchDesignInternalFiltersStep = gql`
  fragment CuratedSearchDesignInternalFiltersStep_AutopilotSearchDesignInternalFiltersStep on AutopilotSearchDesignInternalFiltersStep {
    jobId
    internalFiltersData {
      filters {
        ...AutopilotCuratedInternalSearchContext_InternalSearchFilters
      }
      additionalFiltering
      totalResultCount
      isBestStrategy
    }
  }

  ${AutopilotCuratedInternalSearchContext_InternalSearchFilters}
`;

const CuratedSearchDesignInternalFiltersStep = ({
  data,
}: {
  isCurrentStep: boolean;
  data: CuratedSearchDesignInternalFiltersStep_AutopilotSearchDesignInternalFiltersStepFragment;
}) => {
  const [currentFilters, setCurrentFilters] =
    useState<InternalCuratedSearchFilters>(data.internalFiltersData.filters);
  const [additionalFiltering, setAdditionalFiltering] = useState<string[]>(
    data.internalFiltersData.additionalFiltering ?? [],
  );

  const { onSaveFilters } = useContext(AutopilotCuratedInternalSearchContext);

  return (
    <CuratedInternalSearchFilterCard
      currentFilters={currentFilters}
      setCurrentFilters={(filters) => {
        setCurrentFilters(filters);
      }}
      onSave={async () => {
        await onSaveFilters({ currentFilters, additionalFiltering });
      }}
      curatedSearchId={null}
      additionalFiltering={additionalFiltering}
      setAdditionalFiltering={(additionalFiltering) => {
        setAdditionalFiltering(additionalFiltering);
      }}
    />
  );
};

export default CuratedSearchDesignInternalFiltersStep;
